import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const DISMISS_KEY = 'install-prompt-dismissed';

function isStandalone() {
  return window.matchMedia('(display-mode: standalone)').matches
    || window.navigator.standalone === true;
}

function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

function InstallPrompt() {
  const { t } = useTranslation();
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showIOSGuide, setShowIOSGuide] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isStandalone()) return;
    if (localStorage.getItem(DISMISS_KEY)) return;

    if (isIOS()) {
      setShowIOSGuide(true);
      setVisible(true);
      return;
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setVisible(true);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = useCallback(async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setVisible(false);
    }
    setDeferredPrompt(null);
  }, [deferredPrompt]);

  const handleDismiss = useCallback(() => {
    setVisible(false);
    localStorage.setItem(DISMISS_KEY, 'true');
  }, []);

  if (!visible) return null;

  if (showIOSGuide) {
    return (
      <div className="install-prompt">
        <div className="install-prompt-content">
          <span dangerouslySetInnerHTML={{ __html: t('install.iosGuide') }} />
        </div>
        <button className="install-prompt-btn dismiss" onClick={handleDismiss}>✕</button>
      </div>
    );
  }

  return (
    <div className="install-prompt">
      <div className="install-prompt-content">
        <span>{t('install.androidPrompt')}</span>
      </div>
      <button className="install-prompt-btn accept" onClick={handleInstall}>{t('install.installBtn')}</button>
      <button className="install-prompt-btn dismiss" onClick={handleDismiss}>✕</button>
    </div>
  );
}

export default InstallPrompt;
